import axios from "axios";

axios.defaults.withCredentials = true;

export const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    // Authorization: localStorage
    //   ?.getItem("accessToken")
    //   ?.substring(1, localStorage.getItem("accessToken").length - 1),
  },
});

export const loginInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});
